/**
 * @param {Node} parentItem
 * @description Delete all content of parent item which entered as parameter.
 */ const $771d24a51cd237f6$export$42ffd38884aecdac = function(parentItem) {
    while(parentItem.hasChildNodes())parentItem.removeChild(parentItem.firstChild);
};
const $771d24a51cd237f6$export$21a5ca8aa77d35ff = function(element, action) {
    element.insertAdjacentHTML('beforeend', action);
};


const $5224285b2efb1809$export$c3ee1e672e1e24e7 = 'https://countries.dev';
const $5224285b2efb1809$export$30dba1e0a1cb02c9 = {
    all: 'countries',
    alpha: 'alpha',
    capital: 'capital',
    currency: 'currency',
    demonym: 'demonym',
    ip: 'ip',
    language: 'lang',
    name: 'name',
    region: 'region',
    subregion: 'subregion'
};
const $5224285b2efb1809$export$4e135034a9da2502 = [
    'name',
    'alpha3Code',
    'flags'
].join(',');
const $5224285b2efb1809$export$c085d2ea6894d1b6 = "&#9888 We couldn't find what you're looking for. Try another query.";
const $5224285b2efb1809$export$4048121c58168c2f = "&#9888 We had a problem trying to pull the required data. Please try again.";


const $a0d86b9041cebfad$export$ca000e230c0caa3e = {
    data: null,
    cache: {
        status: null,
        currentCountry: null,
        countries: null,
        countriesAlphabetical: null,
        filteredCountries: null,
        filteredCountriesAlphabetical: null,
        lastSearch: null,
        penultimateSearch: null,
        url: {
            old: null,
            new: null
        }
    }
};
const $a0d86b9041cebfad$export$694b7e19020b03e2 = function(hash) {
    $a0d86b9041cebfad$export$ca000e230c0caa3e.cache.url.old = $a0d86b9041cebfad$export$ca000e230c0caa3e.cache.url.new;
    $a0d86b9041cebfad$export$ca000e230c0caa3e.cache.url.new = hash;
};
const $a0d86b9041cebfad$var$buildUrl = function(endpoint, params = {}) {
    const url = new URL(`${(0, $5224285b2efb1809$export$c3ee1e672e1e24e7)}/${endpoint}`);
    Object.entries(params).forEach(([key, value])=>{
        url.searchParams.set(key, value);
    });
    return url;
};
const $a0d86b9041cebfad$var$fetchJson = async function(endpoint, params) {
    const res = await fetch($a0d86b9041cebfad$var$buildUrl(endpoint, params));
    $a0d86b9041cebfad$export$ca000e230c0caa3e.cache.status = res.status;
    if (!res.ok) return null;
    return await res.json();
};
const $a0d86b9041cebfad$var$formatCountry = function(country) {
    const commonName = country.name || country.nativeName || 'Unknown country';
    const alpha3Code = country.alpha3Code || country.cca3 || country.cioc || '';
    const alpha2Code = country.alpha2Code || country.cca2 || '';
    const callingCodes = country.callingCodes || [];
    return {
        area: country.area,
        altSpellings: country.altSpellings || [],
        borders: country.borders || [],
        capital: country.capital ? [
            country.capital
        ] : [],
        capitalInfo: {
            latlng: country.capitalInfo?.latlng || country.latlng || null
        },
        cca2: alpha2Code,
        cca3: alpha3Code,
        cioc: country.cioc || '',
        currencies: (country.currencies || []).reduce((currencies, cur)=>{
            currencies[cur.code || cur.name] = cur;
            return currencies;
        }, {}),
        demonym: country.demonym || '',
        demonyms: {
            eng: {
                f: country.demonym || '',
                m: country.demonym || ''
            }
        },
        flag: country.flag || '',
        flags: {
            alt: `${commonName} flag`,
            png: country.flags?.png || '',
            svg: country.flags?.svg || country.flag || country.flags?.png || ''
        },
        gini: country.gini,
        idd: {
            root: '+',
            suffixes: callingCodes
        },
        independent: country.independent,
        languages: (country.languages || []).reduce((languages, lang)=>{
            languages[lang.iso639_1 || lang.iso639_2 || lang.name] = lang.name;
            return languages;
        }, {}),
        latlng: country.latlng || [],
        maps: {
            googleMaps: country.maps?.googleMaps || '',
            openStreetMaps: country.maps?.openStreetMaps || ''
        },
        name: {
            common: commonName,
            official: commonName,
            nativeName: country.nativeName || ''
        },
        nativeName: country.nativeName || '',
        numericCode: country.numericCode || '',
        population: country.population,
        populationDensity: country.populationDensity,
        region: country.region || '',
        regionalBlocs: country.regionalBlocs || [],
        subregion: country.subregion || '',
        timezones: country.timezones || [],
        tld: country.topLevelDomain || [],
        translations: country.translations || {}
    };
};
const $a0d86b9041cebfad$var$formatCountries = function(countries) {
    if (!countries) return null;
    if (countries.country) return [
        $a0d86b9041cebfad$var$formatCountry(countries.country)
    ];
    return Array.isArray(countries) ? countries.map($a0d86b9041cebfad$var$formatCountry) : [
        $a0d86b9041cebfad$var$formatCountry(countries)
    ];
};
const $a0d86b9041cebfad$var$sortCountries = function(countries) {
    countries.sort((a, b)=>{
        if (a.name.common < b.name.common) return -1;
        if (a.name.common > b.name.common) return 1;
        return 0;
    });
};
const $a0d86b9041cebfad$var$cacheCountries = function(countries, cacheKey, alphabeticalCacheKey) {
    $a0d86b9041cebfad$export$ca000e230c0caa3e.cache[cacheKey] = countries;
    $a0d86b9041cebfad$export$ca000e230c0caa3e.cache[alphabeticalCacheKey] = [
        ...countries
    ];
    $a0d86b9041cebfad$var$sortCountries($a0d86b9041cebfad$export$ca000e230c0caa3e.cache[alphabeticalCacheKey]);
};
const $a0d86b9041cebfad$var$fetchCountries = async function(endpoint, params) {
    return $a0d86b9041cebfad$var$formatCountries(await $a0d86b9041cebfad$var$fetchJson(endpoint, params));
};
const $a0d86b9041cebfad$var$getCountriesByCodes = async function(codes) {
    const codeList = decodeURI(codes).split(',').map((code)=>code.trim()).filter(Boolean);
    const countries = await Promise.all(codeList.map(async (code)=>{
        const data = await $a0d86b9041cebfad$var$fetchJson(`${(0, $5224285b2efb1809$export$30dba1e0a1cb02c9).alpha}/${encodeURIComponent(code)}`, {
            full: true
        });
        return data ? $a0d86b9041cebfad$var$formatCountry(data) : null;
    }));
    const filteredCountries = countries.filter(Boolean);
    $a0d86b9041cebfad$export$ca000e230c0caa3e.cache.status = filteredCountries.length > 0 ? 200 : 404;
    return filteredCountries.length > 0 ? filteredCountries : null;
};
const $a0d86b9041cebfad$var$findCountriesByLanguage = async function(query) {
    await $a0d86b9041cebfad$export$295b74b5bfa1a9f4();
    if (!$a0d86b9041cebfad$export$ca000e230c0caa3e.cache.countries) return null;
    const normalizedQuery = decodeURI(query).toLowerCase();
    const countries = $a0d86b9041cebfad$export$ca000e230c0caa3e.cache.countries.filter((country)=>Object.entries(country.languages).some(([code, name])=>code.toLowerCase() === normalizedQuery || name.toLowerCase() === normalizedQuery));
    $a0d86b9041cebfad$export$ca000e230c0caa3e.cache.status = countries.length > 0 ? 200 : 404;
    return countries.length > 0 ? countries : null;
};
const $a0d86b9041cebfad$var$findCountriesByCurrency = async function(query) {
    await $a0d86b9041cebfad$export$295b74b5bfa1a9f4();
    if (!$a0d86b9041cebfad$export$ca000e230c0caa3e.cache.countries) return null;
    const normalizedQuery = decodeURI(query).toLowerCase();
    const countries = $a0d86b9041cebfad$export$ca000e230c0caa3e.cache.countries.filter((country)=>Object.values(country.currencies).some((cur)=>cur.code?.toLowerCase() === normalizedQuery || cur.name?.toLowerCase() === normalizedQuery));
    $a0d86b9041cebfad$export$ca000e230c0caa3e.cache.status = countries.length > 0 ? 200 : 404;
    return countries.length > 0 ? countries : null;
};
const $a0d86b9041cebfad$var$findCountriesByTranslation = async function(query) {
    await $a0d86b9041cebfad$export$295b74b5bfa1a9f4();
    if (!$a0d86b9041cebfad$export$ca000e230c0caa3e.cache.countries) return null;
    const normalizedQuery = decodeURI(query).toLowerCase();
    const countries = $a0d86b9041cebfad$export$ca000e230c0caa3e.cache.countries.filter((country)=>Object.values(country.translations).some((translation)=>translation.toLowerCase().includes(normalizedQuery)));
    $a0d86b9041cebfad$export$ca000e230c0caa3e.cache.status = countries.length > 0 ? 200 : 404;
    return countries.length > 0 ? countries : null;
};
const $a0d86b9041cebfad$var$initData = function() {
    try {
        $a0d86b9041cebfad$export$ca000e230c0caa3e.data = {
            version: 2,
            theme: 'light',
            sort: 'random',
            saved: []
        };
        localStorage.setItem('data', JSON.stringify($a0d86b9041cebfad$export$ca000e230c0caa3e.data));
    } catch (err) {
        console.error(err);
    }
};
const $a0d86b9041cebfad$export$a2b9ece0e6f783e0 = function() {
    if (localStorage.getItem('data')) {
        const checkObj = JSON.parse(localStorage.getItem('data'));
        switch(checkObj.version){
            case 2:
                $a0d86b9041cebfad$export$ca000e230c0caa3e.data = checkObj;
                break;
            case 1:
                $a0d86b9041cebfad$export$ca000e230c0caa3e.data = checkObj;
                $a0d86b9041cebfad$export$ca000e230c0caa3e.data.sort = 'random';
                $a0d86b9041cebfad$export$ca000e230c0caa3e.data.version = 2;
                localStorage.setItem('data', JSON.stringify($a0d86b9041cebfad$export$ca000e230c0caa3e.data));
                break;
            default:
                localStorage.clear();
                $a0d86b9041cebfad$var$initData();
                break;
        }
    } else $a0d86b9041cebfad$var$initData();
};
const $a0d86b9041cebfad$export$ea3efea0b3e8773 = async function() {
    try {
        const countries = await $a0d86b9041cebfad$var$fetchCountries((0, $5224285b2efb1809$export$30dba1e0a1cb02c9).all, {
            fields: (0, $5224285b2efb1809$export$4e135034a9da2502)
        });
        if (!countries) return;
        $a0d86b9041cebfad$var$cacheCountries(countries, 'countries', 'countriesAlphabetical');
    } catch (err) {
        console.error(err);
    }
};
const $a0d86b9041cebfad$export$295b74b5bfa1a9f4 = async function() {
    try {
        const countries = await $a0d86b9041cebfad$var$fetchCountries((0, $5224285b2efb1809$export$30dba1e0a1cb02c9).all, {
            full: true
        });
        if (!countries) return;
        $a0d86b9041cebfad$var$cacheCountries(countries, 'countries', 'countriesAlphabetical');
    } catch (err) {
        console.error(err);
    }
};
const $a0d86b9041cebfad$export$a27f7d52d5670305 = async function(cca3) {
    try {
        $a0d86b9041cebfad$export$ca000e230c0caa3e.cache.currentCountry = null;
        $a0d86b9041cebfad$export$ca000e230c0caa3e.cache.currentCountry = await $a0d86b9041cebfad$var$fetchCountries(`${(0, $5224285b2efb1809$export$30dba1e0a1cb02c9).alpha}/${encodeURIComponent(cca3)}`, {
            full: true
        });
        if ($a0d86b9041cebfad$export$ca000e230c0caa3e.cache.currentCountry?.[0].borders?.length > 0) {
            const borderCountries = await $a0d86b9041cebfad$var$getCountriesByCodes($a0d86b9041cebfad$export$ca000e230c0caa3e.cache.currentCountry[0].borders.join(','));
            if (!borderCountries) return;
            const borderNames = borderCountries.map((item)=>item.name.common);
            borderNames.sort();
            $a0d86b9041cebfad$export$ca000e230c0caa3e.cache.currentCountry[0].borders = borderNames;
        }
    } catch (err) {
        console.error(err);
    }
};
const $a0d86b9041cebfad$export$cfcc0908d6dfb8a6 = async function(query, selectedIndex) {
    try {
        let countries;
        switch(selectedIndex){
            case 1:
                countries = await $a0d86b9041cebfad$var$fetchCountries(`${(0, $5224285b2efb1809$export$30dba1e0a1cb02c9).name}/${encodeURIComponent(decodeURI(query))}`);
                break;
            case 2:
                countries = await $a0d86b9041cebfad$var$fetchCountries(`${(0, $5224285b2efb1809$export$30dba1e0a1cb02c9).alpha}/${encodeURIComponent(decodeURI(query))}`, {
                    full: true
                });
                break;
            case 3:
                countries = await $a0d86b9041cebfad$var$getCountriesByCodes(query);
                break;
            case 4:
                countries = await $a0d86b9041cebfad$var$fetchCountries(`${(0, $5224285b2efb1809$export$30dba1e0a1cb02c9).capital}/${encodeURIComponent(decodeURI(query))}`);
                break;
            case 5:
                countries = await $a0d86b9041cebfad$var$fetchCountries(`${(0, $5224285b2efb1809$export$30dba1e0a1cb02c9).currency}/${encodeURIComponent(decodeURI(query))}`);
                if (!countries) countries = await $a0d86b9041cebfad$var$findCountriesByCurrency(query);
                break;
            case 6:
                countries = await $a0d86b9041cebfad$var$fetchCountries(`${(0, $5224285b2efb1809$export$30dba1e0a1cb02c9).demonym}/${encodeURIComponent(decodeURI(query))}`);
                break;
            case 7:
                countries = await $a0d86b9041cebfad$var$fetchCountries(`${(0, $5224285b2efb1809$export$30dba1e0a1cb02c9).language}/${encodeURIComponent(decodeURI(query))}`);
                if (!countries) countries = await $a0d86b9041cebfad$var$findCountriesByLanguage(query);
                break;
            case 8:
                countries = await $a0d86b9041cebfad$var$fetchCountries(`${(0, $5224285b2efb1809$export$30dba1e0a1cb02c9).region}/${encodeURIComponent(decodeURI(query))}`);
                break;
            case 9:
                countries = await $a0d86b9041cebfad$var$fetchCountries(`${(0, $5224285b2efb1809$export$30dba1e0a1cb02c9).subregion}/${encodeURIComponent(decodeURI(query))}`);
                break;
            case 10:
                countries = await $a0d86b9041cebfad$var$findCountriesByTranslation(query);
                break;
            case 11:
                countries = await $a0d86b9041cebfad$var$fetchCountries(`${(0, $5224285b2efb1809$export$30dba1e0a1cb02c9).ip}/${encodeURIComponent(decodeURI(query))}`);
                break;
            default:
                countries = await $a0d86b9041cebfad$var$fetchCountries(`${(0, $5224285b2efb1809$export$30dba1e0a1cb02c9).name}/${encodeURIComponent(decodeURI(query))}`);
                break;
        }
        if (!countries) return;
        $a0d86b9041cebfad$var$cacheCountries(countries, 'filteredCountries', 'filteredCountriesAlphabetical');
    } catch (err) {
        console.error(err);
    }
};




class $e72b216bdf7391d7$export$2e2bcd8739ae039 {
    theme;
    isDetailsOpened = false;
    spinnerMain = document.querySelector('.loader-container--main');
    spinnerDetails = document.querySelector('.loader-container--details');
    popup = document.querySelector('.popup');
    overlay = document.querySelector('.overlay');
    notFound = document.querySelector('.cflex__not-found');
    badRequest = document.querySelector('.cflex__bad-request');
    errorMessage = document.querySelector('.error-message');
    saveIcon = document.querySelector('.details__save-icon .save');
    unsaveIcon = document.querySelector('.details__save-icon .unsave');
    // STATUS METHODS
    renderSpinner(place) {
        switch(place){
            case 'main':
                this.spinnerMain.style.display = 'flex';
            case 'details':
                this.spinnerDetails.style.display = 'flex';
        }
    }
    /**
   * @param {Number} statusCode Status code of error
   * @description Error message which will be shown as text.
   */ renderError(statusCode) {
        (0, $771d24a51cd237f6$export$42ffd38884aecdac)(document.querySelector('.countries'));
        switch(statusCode){
            case 404:
                this.notFound.classList.remove('disabled');
                break;
            default:
                this.badRequest.classList.remove('disabled');
                break;
        }
        this.spinnerMain.style.display = 'none';
    }
    /**
   * @description Implement blur effect to search bar when focused.
   */ renderFocus() {
        document.querySelector('nav.search').style.zIndex = '15';
        document.querySelector('.focus').classList.remove('hidden');
    }
    /**
   * @description Undo blur effect from search bar when not focused anymore.
   */ hideFocus() {
        document.querySelector('nav.search').style.zIndex = '8';
        document.querySelector('.focus').classList.add('hidden');
    }
    addBookmark() {
        this.saveIcon.classList.add('disabled');
        this.unsaveIcon.classList.remove('disabled');
    }
    removeBookmark() {
        this.saveIcon.classList.remove('disabled');
        this.unsaveIcon.classList.add('disabled');
    }
}


class $3a63643955b566e4$var$CountriesView extends (0, $e72b216bdf7391d7$export$2e2bcd8739ae039) {
    #listCards = document.querySelector('.countries');
    #toolSearchBy = document.querySelector('.country-tool--search-by');
    #toolSort = document.querySelector('.country-tool--sort');
    #toolRandom = document.querySelector('.country-tool--random');
    #toolSaved = document.querySelector('.country-tool--saved');
    #toolShowAll = document.querySelector('.country-tool--show-all');
    #title = document.querySelector('.cflex__title');
    render(data, theme, title) {
        (0, $771d24a51cd237f6$export$42ffd38884aecdac)(this.#listCards);
        this.notFound.classList.add('disabled');
        data.forEach((item, index)=>{
            const cardContent = `
        <hover cca3="${item.cca3}" tabindex="${index + 10}">
          <a class="country country--${theme}" href="#country?cca3=${item.cca3}">
            <div class="country__flag"></div>
            <div class="country__name">${item.name.common}</div>
          </a>
        </hover>
`;
            (0, $771d24a51cd237f6$export$21a5ca8aa77d35ff)(this.#listCards, cardContent);
            document.querySelector(`article hover:nth-child(${index + 1}) .country .country__flag`).style.backgroundImage = `url(${item.flags.svg})`;
        });
        this.spinnerMain.style.display = 'none';
        this.#title.textContent = title;
    }
    /**
   * @param {Node} input An input which comes from input variable in controller.
   */ renderShowAll(input) {
        this.#toolSearchBy.classList.add('disabled');
        this.#toolSort.classList.add('disabled');
        this.#toolRandom.classList.add('disabled');
        this.#toolSaved.classList.add('disabled');
        this.#toolShowAll.classList.remove('disabled');
        if (input) input.value = '';
    }
    hideShowAll() {
        this.#toolSearchBy.classList.remove('disabled');
        this.#toolSort.classList.remove('disabled');
        this.#toolRandom.classList.remove('disabled');
        this.#toolSaved.classList.remove('disabled');
        this.#toolShowAll.classList.add('disabled');
        this.renderSpinner();
    }
}
var $3a63643955b566e4$export$2e2bcd8739ae039 = new $3a63643955b566e4$var$CountriesView();




class $f256fdd605197403$var$DetailsView extends (0, $e72b216bdf7391d7$export$2e2bcd8739ae039) {
    body = document.querySelector('body');
    details = document.querySelector('.popup');
    detailsContent = document.querySelector('.details__content');
    osmap = document.querySelector('.details__map-button--openstreetmap');
    gmaps = document.querySelector('.details__map-button--googlemaps');
    saveIcon = document.querySelector('.details__save-icon .save');
    unsaveIcon = document.querySelector('.details__save-icon .unsave');
    detailsButton = document.querySelector('.details__title-button--details');
    mapButton = document.querySelector('.details__title-button--map');
    switchCheckButton = document.querySelector('.switch input[type="checkbox"]');
    detailsErrorMsgBox = document.querySelector('details__bad-request');
    detailsErrorMsg = document.querySelector('details__bad-request error-message');
    #buttonHoverHandler(detailsButton, mapButton, display) {
        this.detailsButton.style.backgroundColor = detailsButton;
        this.mapButton.style.backgroundColor = mapButton;
        [
            this.detailsButton,
            this.mapButton
        ].forEach((el)=>{
            el.addEventListener('mouseover', ()=>{
                el.style.backgroundColor = '#dddddd';
            });
        });
        this.detailsButton.addEventListener('mouseleave', ()=>{
            this.detailsButton.style.backgroundColor = detailsButton;
        });
        this.mapButton.addEventListener('mouseleave', ()=>{
            this.mapButton.style.backgroundColor = mapButton;
        });
        document.querySelector('.details__buttonbar').style.display = display;
    }
    renderError() {
        this.spinnerDetails.style.display = 'none';
        const errorMessage = `
      <div></div>
      <div></div>
      <p class="error-message">
        We've encountered an error. Please try again later.
      </p>
    `;
        (0, $771d24a51cd237f6$export$21a5ca8aa77d35ff)(this.detailsContent, errorMessage);
    }
    renderPre() {
        this.#buttonHoverHandler('#eeeeee', 'transparent', 'none');
        this.isDetailsOpened = true;
        document.querySelector('nav.search').style.zIndex = '8';
        this.renderSpinner('details');
        this.body.style.overflowY = 'hidden';
        this.details.classList.remove('hidden');
    }
    #formatNumber(data) {
        if (data === undefined || data === null) return 'No data';
        return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
    #formatArea(data) {
        if (data === undefined || data === null) return 'No data';
        return `${this.#formatNumber(data)} km2`;
    }
    #formatDensity(data) {
        if (data === undefined || data === null) return 'No data';
        return `${data} people / km2`;
    }
    #formatCodes(data) {
        return [
            data.cca2 && `Alpha-2: ${data.cca2}`,
            data.cca3 && `Alpha-3: ${data.cca3}`,
            data.numericCode && `Numeric: ${data.numericCode}`
        ].filter(Boolean).join(', ');
    }
    #formatRegionalBlocs(data) {
        if (!data?.length) return 'No data';
        return data.map((bloc)=>`${bloc.name}${bloc.acronym ? ` (${bloc.acronym})` : ''}`).join(', ');
    }
    render(data, isSaved, theme) {
        this.#buttonHoverHandler('#eeeeee', 'transparent', 'none');
        data = data[0];
        if (isSaved) {
            this.saveIcon.classList.add('disabled');
            this.unsaveIcon.classList.remove('disabled');
        } else {
            this.saveIcon.classList.remove('disabled');
            this.unsaveIcon.classList.add('disabled');
        }
        const currencyValues = Object.values(data.currencies || {});
        const languageValues = Object.values(data.languages || {});
        let currencies = '';
        let languages = '';
        if (currencyValues.length > 0) currencyValues.forEach((cur)=>{
            currencies += `${cur.name} (${cur.symbol || '?'}), `;
        });
        else currencies = 'No data  ';
        if (languageValues.length > 0) languageValues.forEach((lang)=>{
            languages += `${lang}, `;
        });
        else languages = 'No data  ';
        const markup = `
    <div class="details__flag">
      <img src="${data.flags.svg}" alt="${data.flags.alt || data.demonyms?.eng?.m + ' flag'}" />
    </div>
    <div class="details__list">
      <div class="details__list-item details__list-item--${theme}">
        <p>Alt Spellings:</p>
        <span>${data.name.common + ', ' + data.altSpellings.join(', ')}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Area:</p>
        <span>${this.#formatArea(data.area)}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Borders:</p>
        <span>${data.borders?.length ? data.borders.join(', ') : 'No borders'}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Capital:</p>
        <span>${data.capital?.join(', ') || 'No data'}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Country Codes:</p>
        <span>${this.#formatCodes(data) || 'No data'}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Currencies:</p>
        <span>${currencies.slice(0, currencies.length - 2)}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Demonym:</p>
        <span>${data.demonym || 'No data'}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Direct Dialing Code:</p>
        <span>${data.idd.suffixes?.length ? data.idd.suffixes.map((code)=>`${data.idd.root}${code}`).join(', ') : 'No data'}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Flag Emoji:</p>
        <span>${data.flag || 'No data'}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>GINI:</p>
        <span>${data.gini ?? 'No data'}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Independent:</p>
        <span>${data.independent ? 'Yes' : 'No'}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Native Name:</p>
        <span>${data.nativeName || 'No data'}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Languages:</p>
        <span>${languages.slice(0, languages.length - 2)}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Location:</p>
        <span>${data.latlng.join(', ')}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Population:</p>
        <span>${this.#formatNumber(data.population)}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Population Density:</p>
        <span>${this.#formatDensity(data.populationDensity)}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Region:</p>
        <span>${data.region} / ${data.subregion || '?'}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Regional Blocs:</p>
        <span>${this.#formatRegionalBlocs(data.regionalBlocs)}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Timezones:</p>
        <span>${data.timezones.join(', ')}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Top Level Domain:</p>
        <span>${data.tld?.join(', ') || 'No data'}</span>
      </div>
      <div class="details__list-item details__list-item--${theme}">
        <p>Olympic Code:</p>
        <span>${data.cioc || 'No data'}</span>
      </div>
      <div class="details__note details__note--${theme}">
        <p>
          Car driving direction, coat of arms, continents, landlocked status,
          start of week, and United Nations membership are no longer supported.
          <a target="_blank" rel="noopener noreferrer" href="https://countries.dev/blog/alternative-to-restcountries">Here's why.</a>
        </p>
        <p>
          The data you see in the Countrypedia web application comes from the
          <a target="_blank" rel="noopener noreferrer" href="https://countries.dev/">countries.dev</a>
          API. If the information you see here is not up-to-date or you think
          there are any inaccuracies, you should contact the API provider team.
        </p>
      </div>
    </div>
`;
        this.spinnerDetails.style.display = 'none';
        (0, $771d24a51cd237f6$export$21a5ca8aa77d35ff)(this.detailsContent, markup);
        this.osmap.setAttribute('href', data.maps.openStreetMaps);
        this.gmaps.setAttribute('href', data.maps.googleMaps);
    }
    renderMap(data) {
        data = data[0];
        this.#buttonHoverHandler('transparent', '#eeeeee', 'flex');
        const markup = `<div id="map" class="map"></div>`;
        (0, $771d24a51cd237f6$export$21a5ca8aa77d35ff)(document.querySelector('.details__content'), markup);
        const map = L.map('map').setView([
            data.latlng[0],
            data.latlng[1]
        ], 5);
        const marker = L.marker([
            data.capitalInfo.latlng ? data.capitalInfo.latlng[0] : data.latlng[0],
            data.capitalInfo.latlng ? data.capitalInfo.latlng[1] : data.latlng[1]
        ]).addTo(map);
        marker.bindPopup(`<b style="font-size:1.6rem">${data.name.common}</b><p style="font-size:1rem">${data?.capital || 'No capital'}</p>`, {
            closeButton: true
        }); /*.openPopup();*/ 
        map.createPane('labels');
        map.getPane('labels').style.zIndex = 650;
        map.getPane('labels').style.pointerEvents = 'none';
        L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png', {
            attribution: '<a target="_blank" rel="noopener noreferrer" href="https://www.openstreetmap.org/copyright">\xa9OpenStreetMap</a>, <a target="_blank" rel="noopener noreferrer" href="https://github.com/CartoDB/cartodb/blob/master/LICENSE">\xa9CartoDB</a>'
        }).addTo(map);
    }
    hide() {
        (0, $771d24a51cd237f6$export$42ffd38884aecdac)(document.querySelector('.details__content'));
        this.details.classList.add('hidden');
        this.body.style.overflowY = 'auto';
        this.isDetailsOpened = false;
        this.switchCheckButton.checked = false;
    }
}
var $f256fdd605197403$export$2e2bcd8739ae039 = new $f256fdd605197403$var$DetailsView();



class $0d3d5791fa154221$var$ThemesView extends (0, $e72b216bdf7391d7$export$2e2bcd8739ae039) {
    #body = document.querySelector('body');
    #detailsTitle = document.querySelector('.details__title');
    #cflexTitle = document.querySelector('.cflex__title');
    #country = document.querySelectorAll('.country');
    #countryTool = document.querySelectorAll('.country-tool');
    #footer = document.querySelector('footer');
    #footerText = document.querySelector('.footer__text');
    #footerTextLink = document.querySelectorAll('.footer__link');
    #hero = document.querySelector('.hero');
    #heroTitle = document.querySelector('.hero__title');
    #heroDescription = document.querySelector('.hero__description');
    #search = document.querySelector('.search');
    #searchInput = document.querySelector('.search__input');
    #searchIcon = document.querySelector('.search__icon');
    #toolbarIcon = document.querySelectorAll('.toolbar__icon');
    #details = document.querySelector('.details');
    #detailsListItem = document.querySelectorAll('.details__list-item');
    #dayIcon = document.querySelector('.toolbar__theme--day-icon');
    #nightIcon = document.querySelector('.toolbar__theme--night-icon');
    #badRequestText = document.querySelector('.cflex__bad-request');
    #notFoundText = document.querySelector('.cflex__not-found');
    setNightMode() {
        document.documentElement.style.setProperty('color-scheme', 'dark');
        this.#dayIcon.classList.add('disabled');
        this.#nightIcon.classList.remove('disabled');
        this.#country = document.querySelectorAll('.country');
        this.#body.classList.add('body--dark');
        this.#detailsTitle.classList.add('details__title--dark');
        this.#cflexTitle.classList.add('cflex__title--dark');
        this.#country.forEach((item)=>item.classList.add('country--dark'));
        this.#countryTool.forEach((item)=>item.classList.add('country-tool--dark'));
        this.#footer.classList.add('footer--dark');
        this.#footerText.classList.add('footer__text--dark');
        this.#footerTextLink.forEach((item)=>item.classList.add('footer__link--dark'));
        this.#hero.classList.add('hero--dark');
        this.#heroTitle.classList.add('hero__title--dark');
        this.#heroDescription.classList.add('hero__description--dark');
        this.#search.classList.add('search--dark');
        this.#searchInput.classList.add('search__input--dark');
        this.#searchIcon.classList.add('search__icon--dark');
        this.#badRequestText.classList.add('cflex__bad-request--dark');
        this.#notFoundText.classList.add('cflex__not-found--dark');
        this.#toolbarIcon.forEach((item)=>item.classList.add('toolbar__icon--dark'));
        this.#details.classList.add('details--dark');
        this.#detailsListItem.forEach((item)=>item.classList.add('details__list-item--dark'));
    }
    setDayMode() {
        document.documentElement.style.setProperty('color-scheme', 'light');
        this.#dayIcon.classList.remove('disabled');
        this.#nightIcon.classList.add('disabled');
        this.#country = document.querySelectorAll('.country');
        this.#body.classList.remove('body--dark');
        this.#detailsTitle.classList.remove('details__title--dark');
        this.#cflexTitle.classList.remove('cflex__title--dark');
        this.#country.forEach((item)=>item.classList.remove('country--dark'));
        this.#countryTool.forEach((item)=>item.classList.remove('country-tool--dark'));
        this.#footer.classList.remove('footer--dark');
        this.#footerText.classList.remove('footer__text--dark');
        this.#footerTextLink.forEach((itm)=>itm.classList.remove('footer__link--dark'));
        this.#hero.classList.remove('hero--dark');
        this.#heroTitle.classList.remove('hero__title--dark');
        this.#heroDescription.classList.remove('hero__description--dark');
        this.#search.classList.remove('search--dark');
        this.#searchInput.classList.remove('search__input--dark');
        this.#searchIcon.classList.remove('search__icon--dark');
        this.#badRequestText.classList.remove('cflex__bad-request--dark');
        this.#notFoundText.classList.remove('cflex__not-found--dark');
        this.#toolbarIcon.forEach((item)=>item.classList.remove('toolbar__icon--dark'));
        this.#details.classList.remove('details--dark');
        this.#detailsListItem.forEach((item)=>item.classList.remove('details__list-item--dark'));
    }
}
var $0d3d5791fa154221$export$2e2bcd8739ae039 = new $0d3d5791fa154221$var$ThemesView();



const $6e96969dd7dfd76f$var$viewObj = new (0, $e72b216bdf7391d7$export$2e2bcd8739ae039)();
const $6e96969dd7dfd76f$var$addBookmark = document.querySelector('.details__save-icon');
const $6e96969dd7dfd76f$var$toggler = document.querySelector('.toolbar__theme');
const $6e96969dd7dfd76f$var$search = document.querySelector('.search__button');
const $6e96969dd7dfd76f$var$input = document.querySelector('.search__input');
const $6e96969dd7dfd76f$var$detailsButton = document.querySelector('.details__title-button--details');
const $6e96969dd7dfd76f$var$mapButton = document.querySelector('.details__title-button--map');
const $6e96969dd7dfd76f$var$switchButton = document.querySelector('.slider.round');
const $6e96969dd7dfd76f$var$switchCheckButton = document.querySelector('.switch input[type="checkbox"]');
const $6e96969dd7dfd76f$var$searchby = document.querySelector('#searchby');
const $6e96969dd7dfd76f$var$saveSwitch = document.querySelector('.country-tool__switch input[type="checkbox"]');
const $6e96969dd7dfd76f$var$countryToolSaved = document.querySelector('.country-tool--saved');
window.addEventListener('click', (e)=>{
    if (e.target === document.querySelector('.popup')) window.location.hash = (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.url.old;
});
document.querySelector('#searchby').addEventListener('change', function() {
    switch(this.value){
        case 'name':
            $6e96969dd7dfd76f$var$input.placeholder = 'Search by country name (eg: Germany)';
            break;
        case 'code':
            $6e96969dd7dfd76f$var$input.placeholder = 'Search by country code (eg: per)';
            break;
        case 'codelist':
            $6e96969dd7dfd76f$var$input.placeholder = 'Search by country code list (eg: per,usa,ind)';
            break;
        case 'capital':
            $6e96969dd7dfd76f$var$input.placeholder = 'Search by capital city (eg: Jakarta)';
            break;
        case 'currency':
            $6e96969dd7dfd76f$var$input.placeholder = 'Search by currency (eg: euro)';
            break;
        case 'demonym':
            $6e96969dd7dfd76f$var$input.placeholder = 'Search by demonym (eg: french)';
            break;
        case 'ip':
            $6e96969dd7dfd76f$var$input.placeholder = 'Search by IP address (eg: 8.8.8.8)';
            break;
        case 'lang':
            $6e96969dd7dfd76f$var$input.placeholder = 'Search by language (eg: english)';
            break;
        case 'region':
            $6e96969dd7dfd76f$var$input.placeholder = 'Search by region (eg: africa)';
            break;
        case 'subregion':
            $6e96969dd7dfd76f$var$input.placeholder = 'Search by subregion (eg: caribbean)';
            break;
        case 'translation':
            $6e96969dd7dfd76f$var$input.placeholder = 'Search by country name (eg: Turkki)';
            break;
        default:
            $6e96969dd7dfd76f$var$input.placeholder = 'Search by country name';
            break;
    }
});
document.querySelector('#sort').addEventListener('change', async function() {
    await (0, $a0d86b9041cebfad$export$295b74b5bfa1a9f4)();
    (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.sort = this.value;
    (0, $3a63643955b566e4$export$2e2bcd8739ae039).render(this.value === 'random' ? (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.countries : (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.countriesAlphabetical, (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.theme, 'List of All Countries');
    $6e96969dd7dfd76f$var$listCardHandler();
    localStorage.setItem('data', JSON.stringify((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data));
});
$6e96969dd7dfd76f$var$countryToolSaved.addEventListener('click', function() {
    if (window.location.hash === '#home') {
        $6e96969dd7dfd76f$var$countryToolSaved.setAttribute('href', '#saved');
        $6e96969dd7dfd76f$var$saveSwitch.checked = true;
    } else {
        $6e96969dd7dfd76f$var$countryToolSaved.setAttribute('href', '#home');
        $6e96969dd7dfd76f$var$saveSwitch.checked = false;
    }
});
const $6e96969dd7dfd76f$var$bookmarkHandler = function() {
    try {
        // 1) Check if data is invalid or there is no data
        if (!(0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.countries) return $6e96969dd7dfd76f$var$viewObj.renderError((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.status);
        // 2) Render saved countries
        (0, $3a63643955b566e4$export$2e2bcd8739ae039).render((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.sort === 'random' ? (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.countries.filter((country)=>(0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.saved.includes(country.cca3)) : (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.countriesAlphabetical.filter((country)=>(0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.saved.includes(country.cca3)), (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.theme, 'Saved Countries');
        // 3) Add event listeners to all countries
        $6e96969dd7dfd76f$var$listCardHandler();
    } catch (err) {
        console.error(err);
    }
};
$6e96969dd7dfd76f$var$addBookmark.addEventListener('click', function() {
    try {
        // 1) Check if data is invalid or there is no data
        if (!(0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.countries) return $6e96969dd7dfd76f$var$viewObj.renderError((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.status);
        // 2) Check if country is already saved
        if ((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.saved.includes((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.currentCountry[0].cca3)) {
            // 2.1) Remove country from saved
            (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.saved = (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.saved.filter((cca3)=>cca3 !== (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.country.cca3);
            // 2.2) Remove country from saved countries
            $6e96969dd7dfd76f$var$viewObj.removeBookmark();
            // 2.3) Add event listeners to all countries
            $6e96969dd7dfd76f$var$listCardHandler();
        } else {
            // 3) Add country to saved
            (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.saved.push((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.currentCountry[0].cca3);
            $6e96969dd7dfd76f$var$viewObj.addBookmark();
            // 3.1) Add event listeners to all countries
            $6e96969dd7dfd76f$var$listCardHandler();
        }
        // 4) Save data to local storage
        localStorage.setItem('data', JSON.stringify((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data));
    } catch (err) {
        console.error(err);
    }
});
$6e96969dd7dfd76f$var$toggler.addEventListener('click', function() {
    if ((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.theme === 'light') {
        (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.theme = 'dark';
        (0, $0d3d5791fa154221$export$2e2bcd8739ae039).setNightMode();
    } else {
        (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.theme = 'light';
        (0, $0d3d5791fa154221$export$2e2bcd8739ae039).setDayMode();
    }
    localStorage.setItem('data', JSON.stringify((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data));
});
const $6e96969dd7dfd76f$var$searchTrimHandler = function(untrimmedString) {
    let trimmedString = decodeURI(untrimmedString);
    const arrayTemp = trimmedString.split(',');
    const arrayTemp2 = arrayTemp.map((el)=>el.trim());
    trimmedString = encodeURI(arrayTemp2.join(','));
    return trimmedString;
};
const $6e96969dd7dfd76f$var$searchHandler = async function() {
    // 1) Check for input value is empty or not
    if (!window.location.hash.split('?query=')[1]) return;
    (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.penultimateSearch = (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.lastSearch;
    (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.lastSearch = window.location.hash.split('?query=')[1];
    // 2) If not empty, render spinner before fetch operation
    $6e96969dd7dfd76f$var$viewObj.renderSpinner('main');
    if ($6e96969dd7dfd76f$var$searchby.options.selectedIndex === 3) (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.lastSearch = $6e96969dd7dfd76f$var$searchTrimHandler((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.lastSearch);
    $6e96969dd7dfd76f$var$saveSwitch.checked = false;
    // 3) Fetch data from API
    if ((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.lastSearch !== (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.penultimateSearch) await (0, $a0d86b9041cebfad$export$cfcc0908d6dfb8a6)((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.lastSearch, $6e96969dd7dfd76f$var$searchby.options.selectedIndex);
    if ((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.status !== 200) {
        (0, $3a63643955b566e4$export$2e2bcd8739ae039).renderShowAll();
        // NOTE: WORKAROUND - it will be moved to view later
        $6e96969dd7dfd76f$var$input.blur();
        $6e96969dd7dfd76f$var$input.value = '';
        document.querySelector('.cflex__title').textContent = `Couldn't find any results for "${(0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.lastSearch}"`;
        return $6e96969dd7dfd76f$var$viewObj.renderError((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.status);
    }
    // 4) Render list of countries if data has been received
    (0, $3a63643955b566e4$export$2e2bcd8739ae039).render((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.sort === 'random' ? (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.filteredCountries : (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.filteredCountriesAlphabetical, (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.theme, `Countries matching your search "${decodeURI((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.lastSearch)}"`);
    // 5) Render Show All button to be able to view all countries without having to refresh the page
    (0, $3a63643955b566e4$export$2e2bcd8739ae039).renderShowAll($6e96969dd7dfd76f$var$input);
    $6e96969dd7dfd76f$var$listCardHandler();
    $6e96969dd7dfd76f$var$viewObj.hideFocus();
};
$6e96969dd7dfd76f$var$input.addEventListener('keyup', function(e) {
    if (e.keyCode === 13) $6e96969dd7dfd76f$var$search.click();
});
$6e96969dd7dfd76f$var$input.addEventListener('focus', function() {
    $6e96969dd7dfd76f$var$viewObj.renderFocus();
});
$6e96969dd7dfd76f$var$input.addEventListener('focusout', function() {
    $6e96969dd7dfd76f$var$viewObj.hideFocus();
});
$6e96969dd7dfd76f$var$search.addEventListener('click', function() {
    window.location.hash = '#search?query=' + document.querySelector('.search__input').value.trim();
});
document.querySelector('.details__exit').addEventListener('click', function() {
    $6e96969dd7dfd76f$var$switchCheckButton.checked = false;
    window.location.hash = (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.url.old;
});
const $6e96969dd7dfd76f$var$randomCountryHandler = async function() {
    try {
        // 1) Render spinner before operation
        (0, $f256fdd605197403$export$2e2bcd8739ae039).renderPre();
        // 1) Get random number
        const random = Math.floor(Math.random() * (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.countries.length);
        // 2) Get random country details from random number
        await (0, $a0d86b9041cebfad$export$a27f7d52d5670305)((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.countries[random].cca3);
        // 3) Check if country exists
        if (!(0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.currentCountry) return $6e96969dd7dfd76f$var$viewObj.renderError((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.status);
        // 4) Render country details
        (0, $f256fdd605197403$export$2e2bcd8739ae039).render((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.currentCountry, !!(0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.saved.find((cca3)=>cca3 === (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.currentCountry[0].cca3), (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.theme);
    } catch (err) {
        console.error(err);
    }
};
const $6e96969dd7dfd76f$var$listCardHandler = function() {
    try {
        document.querySelectorAll('.country').forEach((item)=>item.addEventListener('click', async function(event) {
                // 1) Render spinner and countrycard before fetch operation
                (0, $f256fdd605197403$export$2e2bcd8739ae039).renderPre();
                // 2) Get id of the country
                const id = event.target.closest('hover').getAttribute('cca3');
                // 3) Fetch data from API
                await (0, $a0d86b9041cebfad$export$a27f7d52d5670305)(id);
                // 4) Check if data has been received or not
                if (!(0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.currentCountry) return (0, $f256fdd605197403$export$2e2bcd8739ae039).renderError();
                // 5) Render countrycard if data has been received
                (0, $f256fdd605197403$export$2e2bcd8739ae039).render((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.currentCountry, !!(0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.saved.find((cca3)=>cca3 === location.hash.slice(-3)), (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.theme);
            }));
    } catch (err) {
        console.error(err);
    }
};
$6e96969dd7dfd76f$var$switchButton.addEventListener('click', function() {
    (0, $771d24a51cd237f6$export$42ffd38884aecdac)(document.querySelector('.details__content'));
    // Check switchCheckButton checked attribute
    if ($6e96969dd7dfd76f$var$switchCheckButton.checked) {
        if ((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.currentCountry) (0, $f256fdd605197403$export$2e2bcd8739ae039).render((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.currentCountry, !!(0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.saved.find((cca3)=>cca3 === location.hash.slice(-3)), (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.theme);
        else $6e96969dd7dfd76f$var$viewObj.renderError((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.status);
    } else (0, $f256fdd605197403$export$2e2bcd8739ae039).renderMap((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.currentCountry);
});
$6e96969dd7dfd76f$var$detailsButton.addEventListener('click', function() {
    (0, $771d24a51cd237f6$export$42ffd38884aecdac)(document.querySelector('.details__content'));
    if ((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.currentCountry) (0, $f256fdd605197403$export$2e2bcd8739ae039).render((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.currentCountry, !!(0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.saved.find((cca3)=>cca3 === location.hash.slice(-3)), (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.theme);
    else $6e96969dd7dfd76f$var$viewObj.renderError((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.status);
});
$6e96969dd7dfd76f$var$mapButton.addEventListener('click', function() {
    (0, $771d24a51cd237f6$export$42ffd38884aecdac)(document.querySelector('.details__content'));
    (0, $f256fdd605197403$export$2e2bcd8739ae039).renderMap((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.currentCountry);
});
window.addEventListener('hashchange', async function(event) {
    (0, $a0d86b9041cebfad$export$694b7e19020b03e2)(window.location.hash);
    if (window.location.hash.includes('#search')) {
        (0, $f256fdd605197403$export$2e2bcd8739ae039).hide();
        $6e96969dd7dfd76f$var$searchHandler();
    }
    switch(window.location.hash){
        case '#home':
            (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.lastSearch = null;
            if (event.oldURL.includes('#saved') || event.oldURL.includes('#search') || event.oldURL.includes('#country')) $6e96969dd7dfd76f$var$showAllHandler();
            (0, $f256fdd605197403$export$2e2bcd8739ae039).hide();
            break;
        case '#random':
            $6e96969dd7dfd76f$var$randomCountryHandler();
            break;
        case '#saved':
            (0, $f256fdd605197403$export$2e2bcd8739ae039).hide();
            $6e96969dd7dfd76f$var$bookmarkHandler();
            break;
        default:
            break;
    }
});
const $6e96969dd7dfd76f$var$showAllHandler = function() {
    try {
        // 1) Render spinner and hide countrycard
        (0, $3a63643955b566e4$export$2e2bcd8739ae039).hideShowAll();
        // 2) Switch to home page
        (0, $a0d86b9041cebfad$export$694b7e19020b03e2)('#home');
        // 3) Check if fetched data is invalid or there is no data
        if (!(0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.countries) return $6e96969dd7dfd76f$var$viewObj.renderError((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.status);
        // 4) Render all countries if data is valid
        (0, $3a63643955b566e4$export$2e2bcd8739ae039).render((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.sort === 'random' ? (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.countries : (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.countriesAlphabetical, (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.theme, 'List of All Countries');
        // 5) Add event listeners to all countries
        $6e96969dd7dfd76f$var$listCardHandler();
    } catch (err) {
        console.error(err);
    }
};
(async ()=>{
    try {
        // 1) Initialization of URL
        window.location.hash = '#home';
        (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.url.new = window.location.hash;
        // 2) Get data from local storage
        (0, $a0d86b9041cebfad$export$a2b9ece0e6f783e0)();
        // 3) Set theme
        (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.theme === 'light' ? (0, $0d3d5791fa154221$export$2e2bcd8739ae039).setDayMode() : (0, $0d3d5791fa154221$export$2e2bcd8739ae039).setNightMode();
        document.querySelector('#sort').value = (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.sort;
        // 4) Get data from API
        await (0, $a0d86b9041cebfad$export$ea3efea0b3e8773)();
        // 5) Check if fetched data is invalid or there is no data
        if (!(0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.countries) return $6e96969dd7dfd76f$var$viewObj.renderError((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.status);
        // 6) Render all countries if data is valid
        (0, $3a63643955b566e4$export$2e2bcd8739ae039).render((0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.sort === 'random' ? (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.countries : (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).cache.countriesAlphabetical, (0, $a0d86b9041cebfad$export$ca000e230c0caa3e).data.theme, 'List of All Countries');
        // 7) Add event listeners to all countries
        $6e96969dd7dfd76f$var$listCardHandler();
        // 8) Get full data from API
        await (0, $a0d86b9041cebfad$export$295b74b5bfa1a9f4)();
    } catch (err) {
        console.error(err);
    }
})();


//# sourceMappingURL=repo.9f5e2c36.js.map
